import { z } from 'zod';
import { TIPOS_DOCUMENTO } from './cliente';
export const PromotorSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    apellido: z.string().nullable().optional(),
    tipoDocumento: z.string().nullable().optional(),
    nroDocumento: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    esEmpleado: z.boolean(),
    empleadoId: z.string().uuid().nullable().optional(),
    pctOverrideEfectivo: z.union([z.string(), z.number()]).nullable().optional(),
    pctOverrideTarjeta: z.union([z.string(), z.number()]).nullable().optional(),
    frecuenciaLiquidacion: z.string().nullable().optional(),
    activo: z.boolean(),
    creadoEn: z.string(),
    actualizadoEn: z.string(),
});
export const PromotorFormSchema = z.object({
    nombre: z.string().trim().min(1, 'Requerido').max(150),
    apellido: z.string().trim().max(100).optional().or(z.literal('')),
    tipoDocumento: z.enum(TIPOS_DOCUMENTO).optional().or(z.literal('')),
    nroDocumento: z.string().trim().max(50).optional().or(z.literal('')),
    email: z.string().trim().email('Email inválido').max(150).optional().or(z.literal('')),
    telefono: z.string().trim().max(50).optional().or(z.literal('')),
    pctOverrideEfectivo: z.string().optional().or(z.literal('')),
    pctOverrideTarjeta: z.string().optional().or(z.literal('')),
    frecuenciaLiquidacion: z.string().optional().or(z.literal('')),
});
const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const PromotoresPaginadosSchema = z.object({
    items: z.array(PromotorSchema),
    paginacion: PaginacionSchema,
});
// --------------- Comision por sucursal ---------------
export const MODOS_COMISION = ['UNICO', 'POR_METODO_PAGO'];
export const ComisionSucursalSchema = z.object({
    sucursalId: z.string().uuid(),
    modo: z.enum(MODOS_COMISION).nullable().optional(),
    pctUnico: z.union([z.string(), z.number()]).nullable().optional(),
    pctEfectivo: z.union([z.string(), z.number()]).nullable().optional(),
    pctTarjeta: z.union([z.string(), z.number()]).nullable().optional(),
    hereda: z.boolean(),
    actualizadoEn: z.string().optional(),
});
export const ComisionSucursalFormSchema = z
    .object({
    modo: z.enum(MODOS_COMISION).or(z.literal('')),
    pctUnico: z.string().optional().or(z.literal('')),
    pctEfectivo: z.string().optional().or(z.literal('')),
    pctTarjeta: z.string().optional().or(z.literal('')),
})
    .refine((v) => {
    if (v.modo === 'UNICO' && !v.pctUnico)
        return false;
    if (v.modo === 'POR_METODO_PAGO' && (!v.pctEfectivo || !v.pctTarjeta))
        return false;
    return true;
}, { message: 'Completá los porcentajes del modo elegido.', path: ['modo'] });
